import ModalHeader from "./ModalHeader";

function Modal({ modalHeading, handleClose, children, view }) {
  return (
    <div className="modal-backdrop" onClick={handleClose}>
      <div className={`modal-content ${view && "view"}`}>
        <ModalHeader modalHeading={modalHeading} onClick={handleClose} />
        <div className="modal-main">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
